var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#requirements{display:inline-block;padding-top:40px;padding-bottom:80px}#requirements_mac{padding-top:80px;float:left;display:inline}#requirements_ios,#requirements_watch{padding-top:80px;padding-left:200px;float:left;display:inline}#requirements_mac_img{width:181px;height:100px;background:url(" + escape(require("../assets/images/requirements_mac.png")) + ") no-repeat;background-size:contain}#requirements_ios_img{width:100px;height:100px;background:url(" + escape(require("../assets/images/requirements_ios.png")) + ") no-repeat;background-size:contain}#requirements_watch_img{width:100px;height:100px;background:url(" + escape(require("../assets/images/requirements_watch.png")) + ") no-repeat;background-size:contain}.clear{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b077d58","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Requirements.vue
// module id = 87
// module chunks = 0